import Marquee from "react-fast-marquee";

const LOGO = "https://customer-assets-v7afamib.emergentagent.net/job_deductible-to-done/artifacts/puragtdz_Copy%20of%20Herologo.PNG";

const items = [
  "20+ YEARS OF EXPERIENCE",
  "THE ONLY THING THAT'S NEW IS THE ROOF WE GIVE YOU",
  "LICENSED CREWS",
  "STORM DAMAGE SPECIALISTS",
];

export default function ExperienceMarquee() {
  return (
    <section data-testid="marquee-section" className="relative py-10 bg-hero-red overflow-hidden border-y border-hero-reddark">
      <Marquee speed={45} gradient={false} autoFill>
        {items.map((t, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display uppercase text-3xl sm:text-5xl text-white px-8 whitespace-nowrap">{t}</span>
            <img src={LOGO} alt="" aria-hidden="true" className="h-14 w-auto rounded-md bg-white/95 p-1.5 mx-2" />
          </div>
        ))}
      </Marquee>
    </section>
  );
}
